export class FiltrosDocumentosNegociables{

   Tipo_Comprobante : string ='';
   Id : string ='';
   IdAdq : string ='';
   Estado : string ='R';
   Tipo_Emision : string ='';
   Adjunto : string ='';
   Numero : string =''; 
   CodOperacion : string =''; 
   user_id:string='';
   FechaIni:string=''; 
}
